import { INCHES_PER_CM, KG_PER_LB } from './constants';

export const getKgFromLBS = (weightLbs: number) => {
  return Math.floor(weightLbs * KG_PER_LB);
};

export const getLBSFromKg = (kg: number) => {
  return Math.ceil(kg / KG_PER_LB);
};

export const getCmFromInches = (inches: number) => {
  return Math.ceil(inches / INCHES_PER_CM);
};

export const getInchesFromCM = (Cm: number) => {
  return Math.floor(Cm * INCHES_PER_CM);
};
